export const Fields = {
	Event: 'event',
	FilterName: 'filterName',
	FilterSelected: 'filterSelected',
};

export const Constants = {
	EventAdd: 'filterField' as const,
	EventRemove: 'filter entfernen' as const,
};
